'use strict';

var baseUrl = require('./baseUrl.js');
var log = require('loglevel');

function loadError(url, err) {
	log.error('Failed to load style "'+ url +'". Error:', err);
}

function loadStyle(url, onload) {
	var elem = document.createElement('link');
	elem.href = baseUrl(url);
	elem.rel = 'stylesheet';
	elem.type = 'text/css';
	if (onload !== undefined) {
		elem.onload = onload;
	}
	elem.onerror = loadError.bind(this, url);
	document.body.appendChild(elem);
}

module.exports = loadStyle;